import * as THREE from 'three';

import InteractiveControls from './controls/InteractiveControls';
import Particles from './particles/Particles';
import { SamplesMain } from './SamplesMain';
const path = window.mediaPath;
export default class WebGLView {

    constructor(app, type) {
        this.app = app;
        this.img = window.img;
        this.isHide = false;
        this.path = window.mediaPath;
        this.samples = SamplesMain;
        this.resolution = [2560, 1444];
        // this.samples = [
        //     `${this.path}/img/source/1-1.png`, 
        //     `${this.path}/img/source/1-2.png`,
        //     `${this.path}/img/source/1-3.png`,
        //     `${this.path}/img/source/1-4.png`,
        //     `${this.path}/img/source/1-5.png`,
        //     `${this.path}/img/source/1-6.png`,
        //     `${this.path}/img/source/1-7.png`,
        //     `${this.path}/img/source/2-1.png`,
        //     `${this.path}/img/source/2-2.png`,
        //     `${this.path}/img/source/2-3.png`,
        //     `${this.path}/img/source/2-4.png`,
        //     `${this.path}/img/source/2-5.png`,
        //     `${this.path}/img/source/2-6.png`,
        //     `${this.path}/img/source/3-1.jpg`,
        //     `${this.path}/img/source/3-2.png`,
        // ];
        // if(window.outerWidth < 767){
        //     this.resolution = [640, 1080];
        //     this.samples = [
        //         `${this.path}/img/source/mobile/1-1.png`, 
        //         `${this.path}/img/source/mobile/1-2.png`,
        //         `${this.path}/img/source/mobile/1-3.png`,
        //         `${this.path}/img/source/mobile/1-4.png`,
        //         `${this.path}/img/source/mobile/1-5.png`,
        //         `${this.path}/img/source/mobile/1-6.png`,
        //         `${this.path}/img/source/mobile/1-7.png`,
        //         `${this.path}/img/source/mobile/2-1.png`,
        //         `${this.path}/img/source/mobile/2-2.png`,
        //         `${this.path}/img/source/mobile/2-3.png`,
        //         `${this.path}/img/source/mobile/2-4.png`,
        //         `${this.path}/img/source/mobile/2-5.png`,
        //         `${this.path}/img/source/mobile/2-6.png`,
        //         `${this.path}/img/source/mobile/3-1.png`,
        //         `${this.path}/img/source/mobile/3-2.png`,
        //     ];
        // }
        this.initThree();
        this.initParticles();
        this.initControls();
        const rnd = ~~(Math.random() * this.samples.length);
        // this.goto(rnd);
    }
    initThree() {
        this.scene = new THREE.Scene();

        // camera
        this.camera = new THREE.PerspectiveCamera(60, this.resolution[0] / this.resolution[1], 1, 10000);
        this.camera.position.z = 300;

        // renderer
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });

        // clock
        this.clock = new THREE.Clock(true);
    }

    initControls() {
        this.interactive = new InteractiveControls(this.camera, this.renderer.domElement);
    }

    initParticles(type) {
        this.particles = new Particles(this, type);
        this.scene.add(this.particles.container);
    }

    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------

    update() {
        const delta = this.clock.getDelta();
        if (this.particles) this.particles.update(delta);
    }

    draw() {
        this.renderer.render(this.scene, this.camera);
    }


    goto(index) {
        // init next
        if(this.currSample === index && !this.isHide) return;
        if (this.currSample == null) this.particles.init(this.samples[index]);
        // hide curr then init next
        else if (this.isHide) {
            this.particles.init(this.samples[index]);
            this.isHide = false;
        } else {
            this.particles.hide(true).then(() => {
                this.particles.init(this.samples[index]);
            });
        }

        this.currSample = index;
    }
    hide() {
        if (!this.isHide) {
            this.isHide = true;
            this.particles.hide(true);
        }
    }

    next() {

        if (this.currSample < this.samples.length - 1) this.goto(this.currSample + 1);
        else this.goto(0);
    }
    uploadImg() {
            this.samples = [
                window.img
            ];
            this.goto(0);
        }
        // ---------------------------------------------------------------------------------------------
        // EVENT HANDLERS
        // ---------------------------------------------------------------------------------------------

    resize() {
        if (!this.renderer) return;
        this.camera.aspect = this.resolution[0] / this.resolution[1];
        // this.camera.updateProjectionMatrix();

        this.fovHeight = 2 * Math.tan((this.camera.fov * Math.PI) / 180 / 2) * this.camera.position.z;

        this.renderer.setSize(this.resolution[0], this.resolution[1]);

        if (this.interactive) this.interactive.resize();
        if (this.particles) this.particles.resize();
    }
}